import { Popconfirm } from 'antd'
import { PopconfirmProps } from 'antd/lib/popconfirm'
import { PropsWithChildren, useState } from 'react'

export type Props = PopconfirmProps & {
  shouldConfirm: () => boolean
  onConfirm: () => void
}

const ToggleablePopconfirm = ({ shouldConfirm, onConfirm, children, ...otherProps }: PropsWithChildren<Props>) => {
  const [open, setOpen] = useState(false)

  const handleOpenChange = (newOpen: boolean) => {
    if (!newOpen) {
      setOpen(false)
      return
    }

    if (shouldConfirm()) {
      setOpen(true)
    } else {
      onConfirm()
    }
  }

  return (
    <Popconfirm
      {...otherProps}
      open={open}
      onOpenChange={handleOpenChange}
      onConfirm={onConfirm}
    >
      {children}
    </Popconfirm>
  )
}

export default ToggleablePopconfirm
